import React from 'react';

const Materials = () => (
    <div className="content-container">
        <h1>Materials</h1>
        <p>This is the Materials page.</p>
    </div>
);

export default Materials;
